// src/utils/sales/salesMath.js
// Single source of truth for sale P/L math. Pure, no Firestore dependency.

const toNumber = (value) => {
  const parsed = typeof value === 'string' ? parseFloat(value) : value;
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Order total: the full amount the buyer paid, including shipping and tax.
 * salePrice / listingPrice are read for backward compatibility.
 */
export const getItemPrice = (saleData = {}) =>
  toNumber(saleData.price ?? saleData.salePrice ?? saleData.listingPrice);

/**
 * eBay's final value fee is charged on the order total. That total already
 * includes the shipping the buyer paid and the sales tax eBay collected.
 */
export const calculateFeeBasis = (saleData = {}) => getItemPrice(saleData);

/**
 * Calculates net profit for a sale.
 *
 * Start from the order total, then subtract sales tax (remitted by the
 * marketplace), the transaction fee, the shipping label the seller actually
 * paid, and supplies. Shipping the buyer paid stays inside the order total,
 * so buyerShipping is not applied again.
 *
 * @param {Object} saleData - Sale data (numbers or numeric strings)
 * @returns {number} Net profit
 */
export const calculateNetProfit = (saleData = {}) => {
  return (
    getItemPrice(saleData) -
    toNumber(saleData.salesTax) -
    toNumber(saleData.transactionFee) -
    toNumber(saleData.platformFee) -
    toNumber(saleData.shippingCost) -
    toNumber(saleData.packingCost)
  );
};
